import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'

export const Protection = () => {
  const [showModal, setShowModal] = useState(false)
  const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
  const handleOpenModal = (contentType, category, index, maxIndex) => {
      setModalContent({ contentType, category, index, maxIndex })
      setShowModal(true)
  }
  const handleCloseModal = () => {
      setShowModal(false)
  }

    return (
        <>
            <div className='max-w-[1200px] mx-auto'>
                
                <div className='flex justify-center mt-12 '>
                    <img
                        className=''
                        alt='gameflow button'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-protection.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        <span className='text-pborange'>Protection</span> is a special ability that certain characters
                        or items on the map can make use of. It is indicated by a flowing line linking whatever can make
                        use of it. By using Protection, you can enjoy even deeper strategy in battle!
                    </p>{' '}
                    <div className=''>
                        <div className='mt-8 w-full md:w-4/5 mx-auto'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'protection', 1)
                                }}
                                className='ss-thumb max-w-full'
                                alt='gameflow button'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-protection-1-s.webp`}
                            />{' '}
                        </div>{' '}
                        <p className='mt-8'>
                            There are various types of Protection that affect a range of things, such as adding a
                            multiplier to the target when attacking (Attack Power +x%), lowering the DEF stat of the
                            target by x%, (DEF - x%), Prevents Moving, which stops a target from being able to move
                            beyond their current position, blocking certain actions, increasing O.B. damage by x% (O.B.
                            Damage +x%), make the enemies in a character's range of movement target them with Aggro, and
                            much much more.
                        </p>{' '}
                        <div className='mt-8 w-full md:w-4/5 mx-auto'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'protection', 2)
                                }}
                                className='ss-thumb'
                                alt='gameflow button'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-protection-2-s.webp`}
                            />{' '}
                            <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                                Check the effects of Protection by hovering the cursor over a character on the map.
                            </p>
                        </div>
                    </div>{' '}
                    <p className='mt-8'>
                        <span className='text-pborange'>Destroying</span> the item or character causing the Protection
                        causes its <span className='text-pborange'>effect to disappear</span>. Also, if you{' '}
                        <span className='text-pborange'>Confine what is causing the Protection</span>, it will gain that
                        Protection. Try out all of the ways to utilize it in battle!
                    </p>{' '}
                    <div className='mt-8 w-full md:w-4/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal('image', 'protection', 3)
                            }}
                            className='ss-thumb max-w-full'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-protection-3-s.webp`}
                        />{' '}
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            A certain area of the map cannot be entered without removing the No Entry Protection.
                            Protections are not only limited to you or your allies, but also can be extended to the map
                            itself.
                        </p>
                    </div>{' '}
                    <p className='mt-8'>
                        For example, say a rock on the map is causing a Protection that causes enemy characters and
                        grass to have Attack Power +10%. This can be seen by glowing lines linking them, and is a
                        dangerous situation to be in. In this situation, destroying the rock causing this Protection
                        will cause the buff the enemies are receiving to disappear. Alternately, Confining an ally in
                        either the grass receiving the Protection or the rock causing the Protection would cause that
                        Protection's Attack Power +10% to go to that ally. It's up to you to decide the best strategy!
                    </p>{' '}
                    <div className='mt-8 w-full md:w-4/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal('image', 'protection', 4)
                            }}
                            className='ss-thumb max-w-full'
                            alt='gameflow button'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-protection-4-s.webp`}
                        />{' '}
                    </div>{' '}
                </div>{' '}
                <FullScreenModal
                    showModal={showModal}
                    modalContent={modalContent}
                    setModalImage
                    handleCloseModal={handleCloseModal}
                    setModalContent={setModalContent}
                    maxIndex={4}
                />
            </div>
        </>
    )
}
